import {
  type FC, useCallback,
} from 'react';
import { ActiveBoundaryContainer } from '~/sidebar/sidebarApps/mapTools/boundary/activeBoundary/activeBoundary.container';
import { isBTGAiGenerated } from '~/sidebar/sidebarApps/mapTools/boundary/boundaryItem.helpers';
import { useBoundaryGroupsSelector } from '~/store/boundaryGroups/boundaryGroups.selectors';
import { useBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { useIsMapEditDisabled } from '~/store/selectors/useMapInfoSelectors';
import { useOptimizedWMSTerritoriesEnabledSelector } from '~/store/userData/userData.selectors';

type ActiveBoundariesComponentProps = {
  legendMode?: boolean;
  isSubheaderHidden?: boolean;
};

export const ActiveBoundariesComponent: FC<ActiveBoundariesComponentProps> = ({ legendMode, isSubheaderHidden }) => {
  const boundaryTerritoryGroups = useBoundaryTerritoryGroupsSelector();
  const boundaryGroups = useBoundaryGroupsSelector();
  const optimizedTerritoriesEnabled = useOptimizedWMSTerritoriesEnabledSelector();
  const isEditModeDisabled = useIsMapEditDisabled();

  const isHidden = useCallback((boundary: BoundaryTerritoryGroup) => {
    return isEditModeDisabled && isBTGAiGenerated(boundary, boundaryGroups) && !optimizedTerritoriesEnabled;
  }, [boundaryGroups, isEditModeDisabled, optimizedTerritoriesEnabled]);

  return (
    <>
      {boundaryTerritoryGroups.filter(item => !isHidden(item)).map((item) => (
        <ActiveBoundaryContainer
          key={item.boundaryTerritoryGroupId}
          boundaryTerritoryGroup={item}
          legendMode={legendMode}
          isSubheaderHidden={isSubheaderHidden}
        />
      ))}
    </>
  );
};
